<template>
  <div id="user" class="text-center container">
  <div v-if="currentUsername === ''">
    <p>タイムアウトしました。再度ログインしてからやり直してください。</p>
    <p @click="toTop()"><router-link to="/">ホームへ</router-link></p>
  </div>
  <div v-else>

    <transition mode="out-in">
      <div class="mail-change" v-if="isMailChange" :key="1">
        <h5>メールアドレスの変更</h5>
        <div class="mt-3">現在のメールアドレス</div>
        <div>{{ currentUsername }}</div>
        <div class="mt-3">
          <b-form-input type="text" placeholder="新しいメールアドレス" v-model="newUsername" />
          <b-form-input type="password" placeholder="パスワード" v-model="currentPasswordWithMail" />
        </div>
        <b-button variant="primary" class="btn btn-lg btn-primary btn-block mt-4"
          @click="mailChange" :disabled="newUsername === '' || currentPasswordWithMail === ''">
          変更する
        </b-button>
        <b-button variant="outline-secondary" class="btn-sm mt-5"
          @click="isMailChange = !isMailChange">
          パスワードの変更はこちら
        </b-button>
      </div>
      <div class="password-change" v-else :key="2">
        <h5>パスワードの変更</h5>
        <div class="mt-5">
          <b-form-input type="password" placeholder="現在のパスワード" v-model="currentPasswordWithPass" />
          <b-form-input type="password" placeholder="新しいパスワード" v-model="newPassword" />
          <b-form-input type="password" placeholder="新しいパスワード(確認用)" v-model="newPasswordConf" />
        </div>
        <b-button variant="primary" class="btn btn-lg btn-primary btn-block mt-4"
          @click="passChange" :disabled="newPassword !== newPasswordConf || newPassword === ''" >
          変更する
        </b-button>
        <b-button variant="outline-secondary" class="btn-sm mt-5"
          @click="isMailChange = !isMailChange">メールアドレスの変更はこちら</b-button>
      </div>
    </transition>
    </div>
  </div>

</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'uesr',
  data() {
    return {
      currentUsername: '',
      isMailChange: true,
      newUsername: '',
      currentPasswordWithMail: '',
      currentPasswordWithPass: '',
      newPassword: '',
      newPasswordConf: '',
      message: '',
    };
  },
  mounted() {
    const user = firebase.auth().currentUser;
    if (user) {
      this.currentUsername = user.email;
    }
  },
  computed: {
    ...mapGetters([
      'user',
    ]),
  },
  methods: {
    ...mapActions([
      'SignOut',
      'storeIsLoading',
    ]),
    mailChange() {
      this.storeIsLoading(true);
      this.asyncMailChange()
        .then(() => {
          alert('メールアドレスを変更しました。再度ログインしご利用ください。');
          this.SignOut();
          this.$router.push('/');
        })
        .catch((error) => {
          // An error happened.
          if (error.code === 'auth/email-already-in-use') {
            alert('すでに利用されているメールアドレスです。');
          } else if (error.code === 'auth/wrong-password') {
            alert('パスワードが異なります。');
          } else {
            alert('エラーが発生しました。しばらくしてから再度やり直してください。');
          }
        })
        .finally(() => {
          this.storeIsLoading(false);
        });
    },
    passChange() {
      if (this.newPassword.length < 6 || this.currentPasswordWithPass.length < 6) {
        alert('パスワードは6文字以上で入力してください');
        return;
      }
      if (this.newPassword === this.newPasswordConf) {
        this.storeIsLoading(true);
        this.asyncPassChange()
          .then(() => {
            // Update successful.
            alert('パスワードを更新しました。再度ログインしご利用ください。');
            this.SignOut();
            this.$router.push('/');
          })
          .catch((error) => {
            // An error happened.
            if (error.code === 'auth/wrong-password') {
              alert('現在のパスワードが異なります。');
            } else {
              alert('エラーが発生しました。しばらくしてから再度やり直してください。');
            }
          })
          .finally(() => {
            this.storeIsLoading(false);
          });
      } else {
        alert('新しいパスワードと確認用パスワードが異なります。');
      }
    },
    toTop() {
      this.SignOut();
      this.$router.push('/');
    },
    async asyncMailChange() {
      const user = firebase.auth().currentUser;
      const credential = firebase.auth.EmailAuthProvider.credential(
        user.email,
        this.currentPasswordWithMail,
      );
      await user.reauthenticateWithCredential(credential);
      await user.updateEmail(this.newUsername);
    },
    async asyncPassChange() {
      const user = firebase.auth().currentUser;
      const credential = firebase.auth.EmailAuthProvider.credential(
        user.email,
        this.currentPasswordWithPass,
      );
      await user.reauthenticateWithCredential(credential);
      await user.updatePassword(this.newPassword);
    },
  },
};
</script>

<style scoped>
.v-enter-active, .v-leave-active {
  transition: opacity .2s;
}
.v-enter, .v-leave-to {
  opacity: 0;
}

#user{
  max-width: 330px;
  margin-top: 120px;
  margin-bottom: 150px;
}


</style>



// WEBPACK FOOTER //
// src/views/User.vue